import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";

/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React, { Component } from 'react';
import PlaybackSpeed from './PlaybackSpeed';
import PlayerPopover from '../../PlayerPopover';
import MediaContext from '../../Player/MediaContext';
/**
---
private: true
---
@module PlaybackSpeedContainer
**/

var PlaybackSpeedContainer = /*#__PURE__*/function (_Component) {
  _inherits(PlaybackSpeedContainer, _Component);

  function PlaybackSpeedContainer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PlaybackSpeedContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PlaybackSpeedContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleKeyDown = function (showControls) {
      return function (e) {
        e.preventDefault();
        showControls();
      };
    };

    _this.handleOnSelect = function (setPlaybackSpeed) {
      return function (e, _ref) {
        var _ref2 = _slicedToArray(_ref, 1),
            speed = _ref2[0];

        setPlaybackSpeed(speed);
      };
    };

    _this.handleOnMouseMove = function (showControls) {
      return function () {
        showControls();
      };
    };

    return _this;
  }

  _createClass(PlaybackSpeedContainer, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(MediaContext.Consumer, null, function (_ref3) {
        var state = _ref3.state,
            fullScreenContainerRef = _ref3.fullScreenContainerRef,
            actions = _ref3.actions,
            playbackSpeedOptions = _ref3.playbackSpeedOptions;
        return React.createElement(PlayerPopover, {
          activateControl: actions.activateControl,
          deactivateControl: actions.deactivateControl,
          showControls: state.showControls
        }, function (_ref4, togglePopover) {
          var showPopover = _ref4.showPopover;
          return React.createElement(PlaybackSpeed, Object.assign({
            showPopover: showPopover,
            togglePopover: togglePopover,
            videoId: state.videoId,
            mountNode: fullScreenContainerRef,
            playbackSpeed: state.playbackSpeed,
            playbackSpeedOptions: playbackSpeedOptions,
            handleKeyDown: _this2.handleKeyDown(actions.showControls),
            handleOnSelect: _this2.handleOnSelect(actions.setPlaybackSpeed),
            handleOnMouseMove: _this2.handleOnMouseMove(actions.showControls)
          }, _this2.props));
        });
      });
    }
  }]);

  PlaybackSpeedContainer.displayName = "PlaybackSpeedContainer";
  return PlaybackSpeedContainer;
}(Component);

export { PlaybackSpeedContainer as default };